export function getEnvVar(key) {
  if (typeof process !== 'undefined' && process.env && process.env[key] != null) {
    return process.env[key];
  }
  if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[key] != null) {
    return import.meta.env[key];
  }
  return '';
}

const PAYPAL_FALLBACKS = {
  create: 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/createPayPalOrder',
  capture: 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/capturePayPalOrder',
  cancel: 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/cancelPayPalOrder',
};

const PAYPAL_KEY_MAP = {
  create: ['VUE_APP_FN_CREATE_PAYPAL_ORDER', 'VITE_FN_CREATE_PAYPAL_ORDER'],
  capture: ['VUE_APP_FN_CAPTURE_PAYPAL_ORDER', 'VITE_FN_CAPTURE_PAYPAL_ORDER'],
  cancel: ['VUE_APP_FN_CANCEL_PAYPAL_ORDER', 'VITE_FN_CANCEL_PAYPAL_ORDER'],
};

const ALMA_KEY_MAP = {
  create: ['VUE_APP_FN_CREATE_ALMA_PAYMENT', 'VITE_FN_CREATE_ALMA_PAYMENT'],
  cancel: ['VUE_APP_FN_CANCEL_ALMA_PAYMENT', 'VITE_FN_CANCEL_ALMA_PAYMENT'],
  sync: ['VUE_APP_FN_SYNC_ALMA_PAYMENT', 'VITE_FN_SYNC_ALMA_PAYMENT'],
};

const ALMA_FALLBACKS = {
  create: 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/createAlmaPayment',
  cancel: 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/cancelAlmaPayment',
  sync: 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/syncAlmaPaymentStatus',
};

const KLARNA_KEY_MAP = {
  create: ['VUE_APP_FN_CREATE_KLARNA_PAYMENT', 'VITE_FN_CREATE_KLARNA_PAYMENT'],
  cancel: ['VUE_APP_FN_CANCEL_KLARNA_PAYMENT', 'VITE_FN_CANCEL_KLARNA_PAYMENT'],
  sync: ['VUE_APP_FN_SYNC_KLARNA_PAYMENT', 'VITE_FN_SYNC_KLARNA_PAYMENT'],
};

const KLARNA_FALLBACKS = {
  create: 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/createKlarnaPayment',
  cancel: 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/cancelKlarnaPayment',
  sync: 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/syncKlarnaPaymentStatus',
};

const PUBLIC_CHECKOUT_FALLBACK = 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/createPublicCheckoutOrder';
const PUBLIC_BOOKING_AVAILABILITY_FALLBACK = 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/getPublicBookingAvailability';
const PUBLIC_BOOKING_ADMIN_AVAILABILITY_FALLBACK = 'https://europe-west1-fusco-fit-connect-4b731.cloudfunctions.net/managePublicBookingAdmin?action=availability';
const PUBLIC_BOOKING_CREATE_FALLBACK = 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/createPublicBooking';
const PUBLIC_BOOKING_ADMIN_CREATE_FALLBACK = 'https://europe-west1-fusco-fit-connect-4b731.cloudfunctions.net/managePublicBookingAdmin?action=create';
const PUBLIC_BOOKING_ADMIN_UPDATE_FALLBACK = 'https://europe-west1-fusco-fit-connect-4b731.cloudfunctions.net/managePublicBookingAdmin?action=update';
const PUBLIC_BOOKING_ADMIN_ATTENDANCE_FALLBACK = 'https://europe-west1-fusco-fit-connect-4b731.cloudfunctions.net/managePublicBookingAdmin?action=attendance';
const PUBLIC_BOOKING_ADMIN_DATE_UPDATE_FALLBACK = 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/updatePublicBookingDateAdmin';
const PUBLIC_BOOKING_ADMIN_COMMERCIAL_STATUS_FALLBACK = 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/getPublicBookingCommercialStatusAdmin';
const PUBLIC_BOOKING_ADMIN_DASHBOARD_FALLBACK = 'https://europe-west1-fusco-fit-connect-4b731.cloudfunctions.net/managePublicBookingAdmin?action=dashboard';

const PUBLIC_CHECKOUT_KEY_MAP = [
  'VUE_APP_FN_CREATE_PUBLIC_CHECKOUT_ORDER',
  'VITE_FN_CREATE_PUBLIC_CHECKOUT_ORDER',
];

const PUBLIC_BOOKING_AVAILABILITY_KEY_MAP = [
  'VUE_APP_FN_GET_PUBLIC_BOOKING_AVAILABILITY',
  'VITE_FN_GET_PUBLIC_BOOKING_AVAILABILITY',
];

const PUBLIC_BOOKING_CREATE_KEY_MAP = [
  'VUE_APP_FN_CREATE_PUBLIC_BOOKING',
  'VITE_FN_CREATE_PUBLIC_BOOKING',
];

const PUBLIC_BOOKING_ADMIN_AVAILABILITY_KEY_MAP = [
  'VUE_APP_FN_GET_PUBLIC_BOOKING_AVAILABILITY_ADMIN',
  'VITE_FN_GET_PUBLIC_BOOKING_AVAILABILITY_ADMIN',
];

const PUBLIC_BOOKING_ADMIN_CREATE_KEY_MAP = [
  'VUE_APP_FN_CREATE_PUBLIC_BOOKING_ADMIN',
  'VITE_FN_CREATE_PUBLIC_BOOKING_ADMIN',
];

const PUBLIC_BOOKING_ADMIN_UPDATE_KEY_MAP = [
  'VUE_APP_FN_UPDATE_PUBLIC_BOOKING_ADMIN',
  'VITE_FN_UPDATE_PUBLIC_BOOKING_ADMIN',
];

const PUBLIC_BOOKING_ADMIN_ATTENDANCE_KEY_MAP = [
  'VUE_APP_FN_UPDATE_PUBLIC_BOOKING_ATTENDANCE_ADMIN',
  'VITE_FN_UPDATE_PUBLIC_BOOKING_ATTENDANCE_ADMIN',
];

const PUBLIC_BOOKING_ADMIN_DATE_UPDATE_KEY_MAP = [
  'VUE_APP_FN_UPDATE_PUBLIC_BOOKING_DATE_ADMIN',
  'VITE_FN_UPDATE_PUBLIC_BOOKING_DATE_ADMIN',
];

const PUBLIC_BOOKING_ADMIN_COMMERCIAL_STATUS_KEY_MAP = [
  'VUE_APP_FN_GET_PUBLIC_BOOKING_COMMERCIAL_STATUS_ADMIN',
  'VITE_FN_GET_PUBLIC_BOOKING_COMMERCIAL_STATUS_ADMIN',
];

const PUBLIC_BOOKING_ADMIN_DASHBOARD_KEY_MAP = [
  'VUE_APP_FN_GET_PUBLIC_BOOKING_DASHBOARD_ADMIN',
  'VITE_FN_GET_PUBLIC_BOOKING_DASHBOARD_ADMIN',
];

const TRACK_LINK_SHORT_FALLBACK = 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/l';
const TRACK_LINK_YAMAMOTO_SHARE_FALLBACK = 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/yamamoto';
const TRACK_LINK_YAMAMOTO_APP_FALLBACK = 'https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/yamamoto_app';

const TRACK_LINK_KEY_MAP = {
  externalLink: ['VUE_APP_FN_TRACK_EXTERNAL_LINK', 'VITE_FN_TRACK_EXTERNAL_LINK'],
  externalLinkShort: ['VUE_APP_FN_TRACK_EXTERNAL_LINK_SHORT', 'VITE_FN_TRACK_EXTERNAL_LINK_SHORT'],
  externalLinkYamamotoShare: ['VUE_APP_FN_TRACK_EXTERNAL_LINK_YAMAMOTO_SHARE', 'VITE_FN_TRACK_EXTERNAL_LINK_YAMAMOTO_SHARE'],
  externalLinkYamamotoApp: ['VUE_APP_FN_TRACK_EXTERNAL_LINK_YAMAMOTO_APP', 'VITE_FN_TRACK_EXTERNAL_LINK_YAMAMOTO_APP'],
};

export function getPayPalFunctionUrl(type) {
  const keys = PAYPAL_KEY_MAP[type] || [];
  for (const key of keys) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return PAYPAL_FALLBACKS[type] || '';
}

export function getAlmaFunctionUrl(type) {
  const keys = ALMA_KEY_MAP[type] || [];
  for (const key of keys) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return ALMA_FALLBACKS[type] || '';
}

export function getKlarnaFunctionUrl(type) {
  const keys = KLARNA_KEY_MAP[type] || [];
  for (const key of keys) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return KLARNA_FALLBACKS[type] || '';
}

export function getPublicCheckoutFunctionUrl() {
  for (const key of PUBLIC_CHECKOUT_KEY_MAP) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return PUBLIC_CHECKOUT_FALLBACK;
}

export function getPublicBookingAvailabilityFunctionUrl() {
  for (const key of PUBLIC_BOOKING_AVAILABILITY_KEY_MAP) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return PUBLIC_BOOKING_AVAILABILITY_FALLBACK;
}

export function getCreatePublicBookingFunctionUrl() {
  for (const key of PUBLIC_BOOKING_CREATE_KEY_MAP) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return PUBLIC_BOOKING_CREATE_FALLBACK;
}

export function getPublicBookingAvailabilityAdminFunctionUrl() {
  for (const key of PUBLIC_BOOKING_ADMIN_AVAILABILITY_KEY_MAP) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return PUBLIC_BOOKING_ADMIN_AVAILABILITY_FALLBACK;
}

export function getUpdatePublicBookingDateAdminFunctionUrl() {
  for (const key of PUBLIC_BOOKING_ADMIN_DATE_UPDATE_KEY_MAP) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return PUBLIC_BOOKING_ADMIN_DATE_UPDATE_FALLBACK;
}

export function getPublicBookingCommercialStatusAdminFunctionUrl() {
  for (const key of PUBLIC_BOOKING_ADMIN_COMMERCIAL_STATUS_KEY_MAP) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return PUBLIC_BOOKING_ADMIN_COMMERCIAL_STATUS_FALLBACK;
}

export function getPublicBookingDashboardAdminFunctionUrl() {
  for (const key of PUBLIC_BOOKING_ADMIN_DASHBOARD_KEY_MAP) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return PUBLIC_BOOKING_ADMIN_DASHBOARD_FALLBACK;
}

export function getCreatePublicBookingAdminFunctionUrl() {
  for (const key of PUBLIC_BOOKING_ADMIN_CREATE_KEY_MAP) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return PUBLIC_BOOKING_ADMIN_CREATE_FALLBACK;
}

export function getUpdatePublicBookingAdminFunctionUrl() {
  for (const key of PUBLIC_BOOKING_ADMIN_UPDATE_KEY_MAP) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return PUBLIC_BOOKING_ADMIN_UPDATE_FALLBACK;
}

export function getUpdatePublicBookingAttendanceAdminFunctionUrl() {
  for (const key of PUBLIC_BOOKING_ADMIN_ATTENDANCE_KEY_MAP) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return PUBLIC_BOOKING_ADMIN_ATTENDANCE_FALLBACK;
}

export function getCreatePublicBookingBlockAdminFunctionUrl() {
  return getEnvVar('VUE_APP_FN_CREATE_PUBLIC_BOOKING_BLOCK_ADMIN')
    || getEnvVar('VITE_FN_CREATE_PUBLIC_BOOKING_BLOCK_ADMIN')
    || 'https://europe-west1-fusco-fit-connect-4b731.cloudfunctions.net/managePublicBookingAdmin?action=blockCreate';
}

export function getRemovePublicBookingBlockAdminFunctionUrl() {
  return getEnvVar('VUE_APP_FN_REMOVE_PUBLIC_BOOKING_BLOCK_ADMIN')
    || getEnvVar('VITE_FN_REMOVE_PUBLIC_BOOKING_BLOCK_ADMIN')
    || 'https://europe-west1-fusco-fit-connect-4b731.cloudfunctions.net/managePublicBookingAdmin?action=blockRemove';
}

export function getTrackExternalLinkFunctionUrl() {
  const keys = TRACK_LINK_KEY_MAP.externalLinkShort || TRACK_LINK_KEY_MAP.externalLink || [];
  for (const key of keys) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return TRACK_LINK_SHORT_FALLBACK;
}

export function getTrackExternalYamamotoShareUrl() {
  const keys = TRACK_LINK_KEY_MAP.externalLinkYamamotoShare || [];
  for (const key of keys) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return TRACK_LINK_YAMAMOTO_SHARE_FALLBACK;
}

export function getTrackExternalYamamotoAppUrl() {
  const keys = TRACK_LINK_KEY_MAP.externalLinkYamamotoApp || [];
  for (const key of keys) {
    const value = getEnvVar(key);
    if (value) return value;
  }
  return TRACK_LINK_YAMAMOTO_APP_FALLBACK;
}
